export function formatEllipsis(fullTextStr, maxChar = 30) {
  if (fullTextStr?.length <= maxChar) {
    return fullTextStr;
  }

  return `${fullTextStr?.substr(0, maxChar)}...`;
}
